(function (window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Checkout = window.JVZoo.Checkout || {};
    window.JVZoo.Checkout.BlueSnapV2 = window.JVZoo.Checkout.BlueSnapV2 || {};

    /**
     * Must be synchronized with \Paypal::BLUE_SNAP_SECTION_NAME
     * @type {string}
     */
    window.JVZoo.Checkout.BlueSnapV2.BLUE_SNAP_SECTION_NAME = 'blueSnapSectionName'
    var blueSnapErrorCodes = {
        /** invalidCcNumber, invalidExpDate, invalidCvv Dependent on the tagId **/
        INVALID_CARD: 10,
        /** "CC type is not supported by the merchant"; **/
        CC_TYPE_NOT_SUPPORTED: 22013,
        /** " Token is expired"; **/
        HOSTED_FIELD_TOKEN_EXPIRED: 14040,
        /** " Could not find token"; **/
        HOSTED_FIELD_TOKEN_NOT_RECOGNIZED: 14041,
        /** "Token is not associated with a payment method, please verify your client integration or contact BlueSnap support"; **/
        HOSTED_FIELD_TOKEN_FAILURE_CONTACT_SUPPORT: 14042,
        THREE_D_SECURE_NOT_ENABLED: 14100,
        /** "Session expired please refresh page to continue"; **/
        SESSION_EXPIRED_400: 400,
        SESSION_EXPIRED_403: 403,
        SESSION_EXPIRED_404: 404,
        /** "Internal server error please try again later"; **/
        PLEASE_TRY_AGAIN_LATER: 500,
    }
    var ORDER_PROCESSING = 'Processing BlueSnap Credit Card Transaction...';
    var REQUEST_PROCESSING_MESSAGE_NAME = 'blue_snap_processing';
    /**
     * Must be synchronized with \Paypal::BLUE_SNAP_CARD_LAST_FOUR_DIGITS_FIELD_NAME
     * @type {string}
     */
    var BLUE_SNAP_CARD_LAST_FOUR_DIGITS_FIELD_NAME = 'blueSnapCardLast4Digits';
    var BLUE_SNAP_LAST_FOUR_DIGITS_SELECTOR = 'input[type="hidden"][name="' + BLUE_SNAP_CARD_LAST_FOUR_DIGITS_FIELD_NAME + '"]';

    /**
     * Must be synchronized with \Paypal::BLUE_SNAP_CARD_BRAND_CODE_FIELD_NAME
     * @type {string}
     */
    var BLUE_SNAP_CARD_BRAND_CODE_FIELD_NAME = 'blueSnapCardBrandCode';
    var BLUE_SNAP_CARD_BRAND_CODE_SELECTOR =  'input[type="hidden"][name="' + BLUE_SNAP_CARD_BRAND_CODE_FIELD_NAME + '"]';
    /**
     * Must be synchronized with  \Paypal::BLUE_SNAP_CARD_EXPIRATION_FIELD_NAME
     * @type {string}
     */
    var BLUE_SNAP_CARD_EXPIRATION_FIELD_NAME = 'blueSnapCardExpirationDate';
    var BLUE_SNAP_CARD_EXPIRATION_SELECTOR = 'input[type="hidden"][name="' + BLUE_SNAP_CARD_EXPIRATION_FIELD_NAME + '"]';
    /**
     * Must be synchronized with  \Paypal::BLUE_SNAP_HOSTED_PAYMENT_FIELDS_TOKEN_FIELD_NAME
     * @type {string}
     */
    var BLUE_SNAP_HOSTED_PAYMENT_FIELDS_TOKEN_FIELD_NAME = 'blueSnapHostedPaymentFieldsToken';
    var BLUE_SNAP_HOSTED_PAYMENT_FIELDS_TOKEN_SELECTOR = 'input[type="hidden"][name="' + BLUE_SNAP_HOSTED_PAYMENT_FIELDS_TOKEN_FIELD_NAME + '"]';
    /**
     * Must be synchronized with \JVZoo\Constant\PaymentProcessorTypes::BLUE_SNAP
     * @type {number}
     */
    var BLUE_SNAP_PAYMENT_PROCESSOR_TYPE_ID = 19;
    var _blueSnapSdk = null;
    /**
     * @type {boolean}
     * @private
     */
    var _enable3dSecure = false;
    window.JVZoo.Checkout.BlueSnapV2.publicKey
        = window.JVZoo.Checkout.BlueSnapV2.publicKey || null;
    window.JVZoo.Checkout.BlueSnapV2.hostedPaymentFieldsToken
        = window.JVZoo.Checkout.BlueSnapV2.hostedPaymentFieldsToken || null;
    window.JVZoo.Checkout.BlueSnapV2.isSandbox
        = window.JVZoo.Checkout.BlueSnapV2.isSandbox || null;

    /**
     * This value must match the constant \Paypal::BLUESNAP_SECTION_CCN_FIELD_NAME
     * @type {string}
     * @private
     */
    var _bluesnapSectionCcnSelector = 'div#bluesnapSectionCcn';

    /**
     * This value must match the constant \Paypal::BLUESNAP_SECTION_CCN_FIELD_NAME
     * @type {string}
     * @private
     */
    var _bluesnapSectionExpSelector = 'div#bluesnapSectionExp';

    /**
     * This value must match the constant \Paypal::BLUESNAP_SECTION_CCN_FIELD_NAME
     * @type {string}
     * @private
     */
    var _bluesnapSectionCvvSelector = 'div#bluesnapSectionCvv';

    // region BlueSnap event handlers
    var _onSetupComplete = function () {
        console.warn("BlueSnap setup complete");
    }

    var _on3DSecureChallenge = function () {
        console.warn("BlueSnap 3D Secure Challenge");
    }

    // region Credit Card Number events
    var _onCreditCardNumberFocus = function () {
        // console.warn('_onCreditCardNumberFocus');
        // window.JVZoo.FieldMessages.AddInfoForElement(
        //     _bluesnapSectionCcnSelector,
        //     '_onCreditCardNumberFocus',
        //     '_onCreditCardNumberFocus triggered'
        // );
    };
    var _onCreditCardNumberBlur = function () {
        // console.warn('_onCreditCardNumberBlur');
        // window.JVZoo.FieldMessages.AddWarningForElement(
        //     _bluesnapSectionCcnSelector,
        //     '_onCreditCardNumberBlur',
        //     '_onCreditCardNumberBlur triggered'
        // );
    };
    var _onCreditCardNumberError = function (errorCode, errorDescription) {
        console.warn('_onCreditCardNumberError', errorCode, errorDescription);
        window.JVZoo.FieldMessages.AddErrorForElement(
            _bluesnapSectionCcnSelector,
            '_onCreditCardNumberError',
            'Please provide a valid credit card number.' + (errorDescription ? ' ('+errorDescription+')' : '')
        );
    };
    var _onCreditCardNumberValid = function () {
        console.warn('_onCreditCardNumberValid');
        window.JVZoo.FieldMessages.ClearMessagesForParentElement(_bluesnapSectionCcnSelector);
    }
    // endregion Credit Card Number events

    // region Card Expiration events
    var _onCardExpirationFocus = function () {
        // console.warn('_onCardExpirationFocus');
    };
    var _onCardExpirationBlur = function () {
        // console.warn('_onCardExpirationBlur');
    };
    var _onCardExpirationError = function (errorCode, errorDescription) {
        console.warn('_onCardExpirationError', errorCode, errorDescription);
        window.JVZoo.FieldMessages.AddErrorForElement(
            _bluesnapSectionExpSelector,
            '_onCardVerificationCodeError',
            'Please provide a valid card expiration date.' + (errorDescription ? ' ('+errorDescription+')' : '')
        );
    };
    var _onCardExpirationValid = function () {
        console.warn('_onCardExpirationValid');
        window.JVZoo.FieldMessages.ClearMessagesForParentElement(_bluesnapSectionExpSelector);
    }
    // endregion Card Expiration events

    // region Card Verification Code events
    var _onCardVerificationCodeFocus = function () {
        // console.warn('_onCardVerificationCodeFocus');
    };
    var _onCardVerificationCodeBlur = function () {
        // console.warn('_onCardVerificationCodeBlur');
    };
    var _onCardVerificationCodeError = function (errorCode, errorDescription) {
        console.warn('_onCardVerificationCodeError:', errorCode, errorDescription);
        window.JVZoo.FieldMessages.AddErrorForElement(
            _bluesnapSectionCvvSelector,
            '_onCardVerificationCodeError',
            'Please provide a valid card verification code. ('+errorDescription+')'
        );
    };
    var _onCardVerificationCodeValid = function () {
        console.warn('_onCardVerificationCodeValid');
        window.JVZoo.FieldMessages.ClearMessagesForParentElement(_bluesnapSectionCvvSelector);
    }
    // endregion Card Verification Code events

    // endregion BlueSnap event handlers

    /**
     * @link https://developers.bluesnap.com/v8976-Tools/docs/hosted-payment-fields#section-4-add-a-script-to-initiate-the-hosted-payment-fields-with-your-hosted-fields-token
     */
    window.JVZoo.Checkout.BlueSnapV2.buildBlueSnapConfiguration = function(hostedPaymentFieldsToken) {
        return {
            "3DS": true === _enable3dSecure,
            token: window.JVZoo.Checkout.BlueSnapV2.hostedPaymentFieldsToken,
            onFieldEventHandler: {
                /*OPTIONAL*/
                setupComplete: _onSetupComplete,
                /*OPTIONAL*/
                threeDsChallengeExecuted: _on3DSecureChallenge,
                // Handle focus
                // tagId returns: "ccn", "cvv", "exp"
                onFocus: function (tagId) {
                    switch (tagId) {
                        case  "ccn":
                            return _onCreditCardNumberFocus();
                        case "cvv":
                            return _onCardVerificationCodeFocus();
                        case "exp":
                            return _onCardExpirationFocus();
                    }
                },
                // Handle blur
                onBlur: function (tagId) {
                    switch (tagId) {
                        case  "ccn":
                            return _onCreditCardNumberBlur();
                        case "cvv":
                            return _onCardVerificationCodeBlur();
                        case "exp":
                            return _onCardExpirationBlur();
                    }
                },
                // Handle a change in validation
                // errorDescription is optional. Returns BlueSnap's standard error description
                onError: function (tagId, errorCode, errorDescription) {
                    errorCode = parseInt(errorCode);
                    console.error("ERROR CODE RECEIVED: ", tagId, errorCode, errorDescription);
                    _handleErrorCode(errorCode);
                    switch (tagId) {
                        case  "ccn":
                            return _onCreditCardNumberError(errorCode, errorDescription);
                        case "cvv":
                            return _onCardVerificationCodeError(errorCode, errorDescription);
                        case "exp":
                            return _onCardExpirationError(errorCode, errorDescription);
                    }
                },

                onType: function (tagId, cardType, cardData) {
                    /* cardType will give card type, and only applies to ccn: AMEX, VISA, MASTERCARD, AMEX, DISCOVER, DINERS, JCB */
                    if (null != cardData) {
                        /* cardData is an optional parameter which will provide ccType, last4Digits, issuingCountry, isRegulatedCard, cardSubType, binCategory and ccBin details (only applies to ccn) in a JsonObject */
                        console.log(cardData);
                    }
                },
                onValid: function (tagId) {
                    switch (tagId) {
                        case  "ccn":
                            _onCreditCardNumberValid();
                            return;
                        case "cvv":
                            _onCardVerificationCodeValid();
                            return;
                        case "exp":
                            _onCardExpirationValid();
                            return;
                    }
                }, // Handle a change in validation
            },
            /* example:
                style: {
                "Selector": {
                "Property": "Value",
                "Property2": "Value2"
                },
                "Selector2": {
                "Property": "Value"
                }
            }, */
            style: {
                "input": {
                    //style for all input elements
                    "color": "#7c7c7c",
                    "background-color": "#f7f8fc",
                    "border-radius": "4px",
                    "border-style": "solid",
                    "border-width": "1px",
                    "border-color": "#ccc",
                    "font-size": "14px",
                    "line-height": "42px",
                    "padding": "0 10px",
                    "height": "42px !important",
                    "margin": "0",
                    "transition": "border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out",
                    "width": "calc(100% - 22px)",
                },
                "::placeholder": {
                    'color': '#ACB4BD',
                },
                ":focus": {
                    //style for all input elements on focus event
                    "color": "#495057",
                    "background-color": "#fff",
                    "border-color": "#31abf9",
                    "outline": "0",
                },
                ".invalid": {
                    //style for all input elements when invalid
                    "color": "red",
                    "border-width": '1px',
                }
            }
        };
    };

    var _refreshHostedPaymentFieldsToken = function () {
        var formData = new FormData();
        formData.append(window.JVZoo.Security.GetCsrfFieldName(), window.JVZoo.Security.GetCsrfHash());
        formData.append('vendorUserId', window.JVZoo.Checkout.GetVendorUserId().toString());
        beginProcessing(ORDER_PROCESSING, true);
        return fetch(
            '/callbacks/bluesnapcallbacks/refreshToken',
            {
                method: 'POST',
                headers: {'Accept': 'application/json'},
                mode: 'same-origin',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'error',
                referrerPolicy: "same-origin",
                body: formData,
            }
        )
            .then(function (response) {
                console.log("refresh token response: ", response);
                if (!response.ok) {
                    throw new Error('Network response was not ok: ' + response.statusText);
                }
                return response.json();
            })
            .then(function (data) {
                console.log("refresh token response.data: ", data);
                if (!data.token) {
                    throw new Error('token was not refreshed')
                }
                console.log("calling bluesnap.hostedPaymentFieldsUpdateToken(",data.token,")");
                return data.token;
            })
            .then(function (token) {
                _blueSnapSdk.hostedPaymentFieldsUpdateToken(token);
                var $hiddenFormField = $rootElement.find(BLUE_SNAP_HOSTED_PAYMENT_FIELDS_TOKEN_SELECTOR);
                if ($hiddenFormField.length < 1) {
                    throw new Error("Failed to update form value with new token.");
                }
                var priorValue = $hiddenFormField.val();
                $hiddenFormField.val(token);
                console.log(
                    "Prior Value: ", priorValue,
                    "\n New Value: ", $hiddenFormField.val()
                );
            })
            .catch(function (error) {
                console.log("fetch fresh hosted payment fields token failed: ", error);
            })
            .finally(buildRemoveProcessingMessage(true));
    }

    /**
     * @see https://developers.bluesnap.com/docs/3-d-secure-for-api#section-supported-3-d-secure-object-properties
     */
    var _get3dSecureConfiguration = function () {
        var configuration = {
            "amount": window.JVZoo.Checkout.Get3dSecurePrice(),
            "currency": window.JVZoo.Checkout.GetCurrencyIso2()
        };
        var cardHolderFirstName = window.JVZoo.Checkout.GetCardHolderFirstName();
        if ("string" === typeof(cardHolderFirstName)) {
            configuration["billingFirstName"] = cardHolderFirstName;
        }
        var cardHolderLastName = window.JVZoo.Checkout.GetCardHolderLastName();
        if ("string" === typeof(cardHolderLastName)) {
            configuration["billingLastName"] = cardHolderLastName;
        }

        var billingAddressCountryIso2 = window.JVZoo.Checkout.GetBillingAddressCountryIso2();
        if ("string" === typeof(billingAddressCountryIso2)) {
            configuration["billingCountry"] = billingAddressCountryIso2;
        }

        var countryIso2 = window.JVZoo.Checkout.GetBillingAddressCountryIso2();
        var billingRegion = window.JVZoo.Checkout.GetBillingAddressRegionBySelectedCountry();
        if ("string" === typeof(billingRegion)
            // must be US or CA
            && ("US" === countryIso2 || "CA" === countryIso2)
            // ensure it is length 2
            && 2 === billingRegion.length
        ) {
            /* From BlueSnap Docs:
             *     billingState     string    optional
             *     Value must be the state/province portion of the ISO 3166-2 code, in all uppercase characters.
             *     For example, for US-OH, send OH, or for GB-LND, send LND.
             *     If you are uncertain of the format, it is recommended to not pass a value.
             */
            configuration["billingState"] = billingRegion;
        }

        var billingAddressCity = window.JVZoo.Checkout.GetBillingAddressCity();
        if ("string" === typeof(billingAddressCity)) {
            //billingCity     string    optional
            configuration["billingCity"] = billingAddressCity;
        }

        var billingAddressAllLines = window.JVZoo.Checkout.GetBillingAddressAllLines();
        if ("string" === typeof(billingAddressAllLines)) {
            //billingAddress     string    optional
            configuration["billingAddress"] = billingAddressAllLines;
        }

        var billingAddressPostalCode = window.JVZoo.Checkout.GetBillingAddressPostalCode();
        if ("string" === typeof(billingAddressPostalCode)) {
            //billingZip     string    optional
            configuration["billingZip"] = billingAddressPostalCode;
        }

        /* Shipping value omitted
         *           //shippingFirstName     string    optional
         *           "shippingFirstName": null,
         *           //shippingLastName     string    optional
         *           "shippingLastName": null,
         *           //shippingCountry     string    optional
         *           "shippingCountry": null,
         *           //shippingState     string    optional
         *           "shippingState": null,
         *           //shippingCity     string    optional
         *           "shippingCity": null,
         *           //shippingAddress     string    optional
         *           "shippingAddress": null,
         *           //shippingZip     string    optional
         *           "shippingZip": null,
         */

        var contactEmail = window.JVZoo.Checkout.GetContactEmail();
        if ("string" === typeof(contactEmail)) {
            configuration["email"] =  contactEmail;
        }

        var billingAddressPhoneNumber = window.JVZoo.Checkout.GetBillingAddressPhoneNumber();
        if ("string" === typeof(billingAddressPhoneNumber)) {
            configuration["phone"] =  billingAddressPhoneNumber;
        }

        return configuration;
    };

    /**
     * This method is called from a <script> tag in the application/views/checkout/components/cc_form_blue_snap.twig view
     * @param blueSnapSdk
     * @param checkoutFormSelector
     * @param hostedFieldsToken
     * @param enable3dSecure
     * @param isSandbox
     */
    window.JVZoo.Checkout.BlueSnapV2.initializeBlueSnap = function (
        blueSnapSdk,
        checkoutFormSelector,
        hostedFieldsToken,
        enable3dSecure,
        isSandbox
    ) {
        _blueSnapSdk = blueSnapSdk;
        _enable3dSecure = enable3dSecure;
        var $root = checkoutFormSelector instanceof $ ? checkoutFormSelector : $(checkoutFormSelector);
        if ($root.length !== 1) {
            console.error(
                "Expected to find exactly one Blue Snap Section, but found "
                +($root.length)+" with selector \""+checkoutForm+"\""
            )
            return;
        }

        window.JVZoo.Checkout.BlueSnapV2.applyBindings($root, _blueSnapSdk)

        // window.JVZoo.Checkout.BlueSnapV2.publicKey = publicKey;
        window.JVZoo.Checkout.BlueSnapV2.hostedPaymentFieldsToken = hostedFieldsToken;
        window.JVZoo.Checkout.BlueSnapV2.isSandbox = isSandbox === true;
        var blueSnapConfiguration = window.JVZoo.Checkout.BlueSnapV2.buildBlueSnapConfiguration(hostedFieldsToken)
        console.debug('blueSnapSdk.hostedPaymentFieldsCreate: ', blueSnapConfiguration);
        _blueSnapSdk.hostedPaymentFieldsCreate(blueSnapConfiguration);

    };

    var _handleErrorCode = function (errorCode) {
        switch (parseInt(errorCode)) {
            case blueSnapErrorCodes.HOSTED_FIELD_TOKEN_NOT_RECOGNIZED:
            case blueSnapErrorCodes.HOSTED_FIELD_TOKEN_EXPIRED:
                _refreshHostedPaymentFieldsToken();
                break;
            case blueSnapErrorCodes.THREE_D_SECURE_NOT_ENABLED:
                _enable3dSecure = false;
                $(window.JVZoo.Checkout.PayByCardButtonJquerySelector).prop('disabled', false)
                break;
        }
    }

    var onBlueSnapSubmitResponse =  function(callback){
        window.JVZoo.DisplayMessages.Clear();
        if (window.JVZoo.Debug) {
            console.info("BlueSnap Callback Received: ", callback);
        }
        if (callback.error) {
            for (var i in callback.error) {
                var errorData = callback.error[i];
                var errorCode = parseInt(errorData.errorCode);
                _handleErrorCode(errorCode);
                if (blueSnapErrorCodes.THREE_D_SECURE_NOT_ENABLED === errorCode) {
                    /*
                     * Resubmit but Do Not re-enable UI at this point as that should be done in the finally block that
                     * wraps the BlueSnap call that then calls this code
                     */
                    _blueSnapSdk.hostedPaymentFieldsSubmitData(onBlueSnapSubmitResponse);
                }
                if (window.JVZoo.Debug) {
                    console.error("BlueSnap Processing Error: ", errorData);
                }
                var message = errorData.errorDescription || "BlueSnap "+errorData.eventType;
                window.JVZoo.DisplayMessages.Add(
                    'error',
                    message,
                    'BLUE_SNAP_ERROR_'+(errorData.errorCode)
                );
            }

            return;
        }

        if (!callback.cardData) {
            window.JVZoo.DisplayMessages.Add(
                'error',
                "There is a problem with the provided card information.",
                'BLUE_SNAP_ERROR'
            )
            return;
        }

        if (callback.cardData.last4Digits) {
            $(BLUE_SNAP_LAST_FOUR_DIGITS_SELECTOR).val(callback.cardData.last4Digits);
        }

        if (callback.cardData.exp) {
            $(BLUE_SNAP_CARD_EXPIRATION_SELECTOR).val(callback.cardData.exp);
        }

        if (callback.cardData.ccType) {
            $(BLUE_SNAP_CARD_BRAND_CODE_SELECTOR).val(callback.cardData.ccType);
        }

        window.JVZoo.Checkout.setCheckoutPaymentProcessorTypeId(BLUE_SNAP_PAYMENT_PROCESSOR_TYPE_ID)

        if (window.JVZoo.Debug && !confirm("Submit to JVZoo?")) {
            return;
        }

        beginProcessing(ORDER_PROCESSING, true);
        window.JVZoo.Checkout.ShowCreditCardProcessing();
        window.JVZoo.Checkout.SubmitOrderFormAsCreditCardPayment()
    }

    var buildOnPayByCardButtonClick = function (root) {
        var $rootElement = root instanceof $ ? root : $(root);
        return function (event) {
            event.preventDefault();
            // ensure required fields have been provided
            var _fieldValidators = window.JVZoo.Checkout.Validators.DefaultValidators(
                [
                    window.JVZoo.Checkout.Validators.Index.RequireCcInfoCardHolderFirstNameById,
                    window.JVZoo.Checkout.Validators.Index.RequireCcInfoCardHolderLastNameById,
                    window.JVZoo.Checkout.Validators.Index.RequireBillingAddressLine1ById,
                    window.JVZoo.Checkout.Validators.Index.RequireBillingAddressCityById,
                    window.JVZoo.Checkout.Validators.Index.RequireBillingAddressCountryIso2ById,
                    window.JVZoo.Checkout.Validators.Index.RequireBillingAddressUsStateIso2ById,
                    window.JVZoo.Checkout.Validators.Index.RequireBillingAddressCaProvinceIso2ById,
                    window.JVZoo.Checkout.Validators.Index.RequireBillingAddressRegionNameById,
                    window.JVZoo.Checkout.Validators.Index.RequireBillingAddressPostalCodeById,
                    window.JVZoo.Checkout.Validators.Index.RequireBillingAddressPhoneNumberById,
                ]
            );

            if (!window.JVZoo.Checkout.ValidateBillingInfoSection($rootElement, _fieldValidators)){
                if (window.JVZoo.Debug) {
                    alert('JVZoo Form Validation Failed');
                }
                return;
            }

            if (window.JVZoo.Debug && !confirm('Submitting Payment to BlueSnap')) {
                return;
            }

            if (!_blueSnapSdk) {
                console.error("Unable to submit CC info to BlueSnap because the _blueSnapSdk has not been initialized.");
                return;
            }

            try {
                beginProcessing(ORDER_PROCESSING, true);
                if (_enable3dSecure) {
                    _blueSnapSdk.hostedPaymentFieldsSubmitData(
                        onBlueSnapSubmitResponse,
                        _get3dSecureConfiguration()
                    );
                } else {
                    _blueSnapSdk.hostedPaymentFieldsSubmitData(onBlueSnapSubmitResponse);
                }
            } finally {
                buildRemoveProcessingMessage(true)();
            }
        }
    };

    const removeMessages = function () {
        window.JVZoo.DisplayMessages.RemoveByName(REQUEST_PROCESSING_MESSAGE_NAME);
    }

    const beginProcessing = function (message, disableUserInteraction) {
        removeMessages();
        if (disableUserInteraction) {
            window.JVZoo.Checkout.DisableUserInteraction();
        }
        window.JVZoo.DisplayMessages.Add('info', message, REQUEST_PROCESSING_MESSAGE_NAME);
    };

    const buildRemoveProcessingMessage = function (enableUserInteraction) {
        return function() {
            if (enableUserInteraction) {
                window.JVZoo.Checkout.EnableUserInteraction();
            }
            window.JVZoo.DisplayMessages.RemoveByName(REQUEST_PROCESSING_MESSAGE_NAME);
        }
    };

    window.JVZoo.Checkout.BlueSnapV2.applyBindings = function (root) {
        var $rootElement = root instanceof $ ? root : $(root);

        $rootElement.on(
            'click',
            window.JVZoo.Checkout.PayByCardButtonJquerySelector,
            buildOnPayByCardButtonClick($rootElement)
        );
    };

    $(document).ready(function () {
        // no op

    });

})(window, jQuery);